export default __webpack_public_path__ + "static/media/perspectives.974365be.png";